import React from "react";
import { useNavigate } from "react-router-dom";
import { Film } from "lucide-react";

/**
 * Reusable "Send to AI Avatar Studio" button.
 * Bridges any text-producing studio (News, Commercials, DJ Assistant,
 * Artist Spotlight) into Avatar Studio with a pre-filled script + title.
 * Uses base64-encoded query params to safely shuttle multi-line scripts.
 */
export default function SendToAvatarButton({ script, title, variant = "default", testid = "send-to-avatar" }) {
  const navigate = useNavigate();
  const enabled = !!(script && script.trim());

  const onClick = () => {
    if (!enabled) return;
    // base64 makes multiline + special chars URL-safe; cap so we don't
    // build a 50KB query string by accident.
    const trimmed = String(script).slice(0, 8000);
    const params = new URLSearchParams();
    params.set("script", btoa(unescape(encodeURIComponent(trimmed))));
    if (title) params.set("title", title.slice(0, 120));
    navigate(`/dashboard/avatar-studio?${params.toString()}`);
  };

  const cls = variant === "compact"
    ? "inline-flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-md border border-brand-amber/30 bg-brand-amber/5 text-brand-amber hover:bg-brand-amber/10 transition disabled:opacity-40"
    : "inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-md border border-brand-amber/40 bg-brand-amber/10 text-brand-amber hover:bg-brand-amber/20 transition disabled:opacity-40";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!enabled}
      data-testid={testid}
      className={cls}
      title={enabled ? "Render this script as an AI avatar video" : "Generate or write a script first"}
    >
      <Film className="h-3.5 w-3.5" />
      <span>Send to AI Avatar</span>
    </button>
  );
}
